export default __webpack_public_path__ + "static/media/reload.68d1d9e0.svg";